export default {
  LOAD_COMPETENCY_SURVEY_QUESTION_FORM_PAGE_START: 'LoadCompetencySurveyQuestionFormPageStart',
  LOAD_COMPETENCY_SURVEY_QUESTION_FORM_PAGE_END: 'LoadCompetencySurveyQuestionFormPageEnd',
  SET_COMPETENCY_SURVEY_QUESTION_SUBCOMPETENCY_MATCH_FLAG: 'SetCompetencySurveyQuestionSubcompetencyMatchFlag',
  CLEAR_COMPETENCY_SURVEY_QUESTION_FORM_PAGE: 'ClearCompetencySurveyQuestionFormPageStart',

  LOAD_COMPETENCY_SURVEY_QUESTION_AVAILABLE_SUBCOMPETENCIES_START: 'LoadCompetencySurveyQuestionAvailableSubcompetenciesStart',
  LOAD_COMPETENCY_SURVEY_QUESTION_AVAILABLE_SUBCOMPETENCIES_END: 'LoadCompetencySurveyQuestionAvailableSubcompetenciesEnd'

};